import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import FlyoutMenu from './FlyoutMenu';
import Image from 'next/image';

const items = [
  {
    id: 'wishlist',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_lista_desideri.png',
    rank: 10,
    enabled: true,
    href: '/profile/wishlist',
  },
  {
    id: 'purchases',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_acquistati_recente.png',
    rank: 20,
    enabled: true,
    href: '/profile/recently-purchased',
  },
  {
    id: 'consigliati',
    iconUrl:
      'https://cdn.winelivery.com/public/sections/occasione_consigliati.png',
    rank: 40,
    enabled: true,
    href: `/shop?tag=consigliati`,
  },
  {
    id: 'bestseller',
    iconUrl: 'https://cdn.winelivery.com/public/sections/best_seller.jpg',
    rank: 50,
    enabled: true,
    href: `/shop?tag=bestseller`,
  },
];

function FlyoutMenuSelections() {
  const t = useTranslations('shop');

  return (
    <FlyoutMenu label={t('navbar.selections.title')} fullWidth>
      <div className="container mx-auto py-4 grid grid-cols-3 xl:grid-cols-5 gap-2 px-2">
        {items
          .filter((item) => item.enabled)
          .map((item) => (
            <Link
              key={item.id}
              // @ts-expect-error
              href={item.href}
              className="rounded-lg p-6 hover:bg-greyscale-pink text-left no-underline"
            >
              <div className="relative w-16 h-16 mb-2">
                <Image
                  fill
                  className="object-cover rounded-sm"
                  src={item.iconUrl}
                  alt={t(`navbar.selections.${item.id}.title`)}
                />
              </div>
              <h6 className="text-lg font-bold tracking-tight text-greyscale-body m-0 p-0">
                {t(`navbar.selections.${item.id}.title`)}
              </h6>
              <p className="text-sm font-medium tracking-tight text-greyscale-label m-0 p-0">
                {t(`navbar.selections.${item.id}.description`)}
              </p>
            </Link>
          ))}
      </div>
    </FlyoutMenu>
  );
}

export default FlyoutMenuSelections;
